var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    viewBox: "0 0 283.46 283.46"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "share_svg__a",
    d: "M0 0h283.47v283.47H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "share_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#share_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.8 283.47h-.19a8 8 0 0 1-7.38-5.41l-39.91-116.92L5.41 121.23a7.998 7.998 0 0 1-.35-15.01L138.79 53.4 272.36.63a8.1 8.1 0 0 1 3.66-.61c1.86.13 3.68.9 5.11 2.32l.01.01.01.01a7.97 7.97 0 0 1 2.3 5.06 7.931 7.931 0 0 1-.61 3.68l-52.77 133.57-52.83 133.74a8 8 0 0 1-7.44 5.06m-32-126.5 32.55 95.35 44.84-113.52 38.68-97.9zM31.14 113.11l95.35 32.55L242.56 29.59l-97.9 38.68z",
    style: {
      clipPath: "url(#share_svg__b)"
    }
  }));
};
export default SvgShare;